(function() {

    var embedConsultReserve = {

        init: function() {
            var self = this;
            self.setting();
            self.bindEvents();
        },

        setting: function() {
            var self = this;

            self.$popup = $('#popup-consult-reserve');
            self.$successPopup = $('#popup-consult-reserve-success');
            self.$popupOpenButton = $('[data-btn-link=embedConsultReserve]');
            self.$submitButton = self.$popup.find('[name=consultSubmitButton]');
            self.$consultReserveContents = self.$popup.find('.contents');
            self.$popupOpener = null;
            self.consultLoading = false;
        },

        bindEvents: function() {
            var self = this;

            self.$popupOpenButton.on('click', function(e) {
                self.$popupOpener = $(this);
                self.open();
            });

            self.$submitButton.on('click', function(e) {
                if (lgkorConsultReserve.isValid()) {
                    var obj = {
                        title: '저장하시겠습니까?',
                        cancelBtnName: '아니오',
                        okBtnName: '예',
                        ok: function() {
                            lgkorConsultReserve.reserve();
                        }
                    };
                    lgkorUI.confirm('', obj, self.$submitButton);
                }
            });
        },

        open: function(opener) {
            var self = this;

            if (opener) {
                self.$popupOpener = $(opener);
            }

            // 로그인 여부 확인
            var loginFlag = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";
            if(loginFlag == 'N') {
                lgkorUI.confirm('', {
                    title:'로그인이 필요합니다.<br>이동하시겠습니까?',
                    okBtnName: '네',
                    cancelBtnName: '아니오',
                    ok : function (){
                        window.location.href = '/sso/member/login?state=' + encodeURIComponent(location.href.replace(location.origin, ""));
                    }
                }, self.$popupOpener);
                return;
            }

            self.popupInit();
            self.$popup.vcModal({ opener: self.$popupOpener }).vcModal('open');
        },

        // 초기화
        popupInit: function() {
            var self = this;
            if (self.consultLoading) {
                return;
            }
            self.consultLoading = true;
            self.$consultReserveContents.empty();
            self.setButtonState(self.$submitButton, false);
            lgkorUI.showLoading();

            $.get('/consultReserve/reg-area', { gubun: 'K' })
              .done(function(html) {
                  self.$consultReserveContents.html(html);
                  lgkorConsultReserve.init({
                      container: self.$consultReserveContents,
                      onComplete: self.consultReserveComplete,
                      onFail: self.consultReserveFail,
                      onValidChange: function(isValid) {
                          embedConsultReserve.setButtonState(
                              embedConsultReserve.$submitButton, isValid
                          );
                      }
                  });
                  self.$consultReserveContents.find('.ui_textcontrol').vcTextcontrol();
                  self.appendLegendHtml(); // 달력 범례 마크업 추가
              })
              .fail(function() {
                  lgkorUI.alert("", {
                      title: '구매 상담 예약이 실패했습니다.',
                      ok: function() {
                          self.$popup.vcModal('hide');
                      }
                  }, self.$popupOpener);
              })
              .always(function() {
                  self.consultLoading = false;
                  lgkorUI.hideLoading();
              });
        },

        // 버튼
        setButtonState: function($button, isValid) {
            if (!$button || !$button.length) {
                return;
            }
            if (isValid) {
                $button.removeClass('dark-gray').addClass('pink');
            } else {
                $button.removeClass('pink').addClass('dark-gray');
            }
        },

        // 성공 콜백
        consultReserveComplete: function() {
            embedConsultReserve.$popup.vcModal('hide');
            embedConsultReserve.$successPopup
                .vcModal({ opener: embedConsultReserve.$popupOpener })
                .vcModal('open');
        },

        // 실패 콜백
        consultReserveFail: function() {
            lgkorUI.alert("", {
                title: '구매 상담 예약 신청에 실패했습니다.<br>다시 시도해 주세요.',
                ok: function() {}
            }, embedConsultReserve.$submitButton);
        },

        // 달력 범례 마크업 추가
        insertLegend: function() {
            var legendHtml =
                '<ul class="calendar-info">' +
                    '<li class="black"><span class="blind">검정색 표기</span> 예약가능</li>' +
                    '<li class="red"><span class="blind">빨간색 표기</span> 선택</li>' +
                    '<li class="gray"><span class="blind">회색 표기</span> 불가</li>' +
                '</ul>';
            var $wrap = this.$popup.find('.bx-calendar .calendar-wrap');
            if (!$wrap.length) return false;
            // 이미 있으면 중복 생성 방지
            if ($wrap.next('.calendar-info').length) return true;
            $(legendHtml).insertAfter($wrap);
            return true;
        },

        // 달력 범례 마크업 추가 (observe)
        appendLegendHtml: function() {
            if (this.insertLegend()) return;
            var ob = new MutationObserver(function () {
                if (this.insertLegend()) ob.disconnect();
            });
            ob.observe(this.$popup[0], { childList: true, subtree: true });
        },
    };

    window.embedConsultReserve = embedConsultReserve;

    $(document).ready(function() {
        if ($('#popup-consult-reserve').length) {
            embedConsultReserve.init();
        }
    });

})();
